import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import "./ConfirmationModal.scss";

interface ConfirmationModalProps {
  open: boolean;
  title: string;
  description: string;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  confirmBtnText?: string;
}

const ConfirmationModal = ({
  open,
  title,
  description,
  onClose,
  onConfirm,
  isLoading = false,
  confirmBtnText = "Confirm",
}: ConfirmationModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="confirmation-modal-container"
    >
      <DialogContent className="modal-content">
        <h3 className="modal-title font-inter-500">{title}</h3>

        <p className="modal-description font-inter-400">{description}</p>

        <div className="modal-actions">
          <button className="cancel-btn font-inter-500" onClick={onClose}>
            Cancel
          </button>

          <button
            className="confirm-btn font-inter-500"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : confirmBtnText}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationModal;
